export const STORE_ADMIN_PRE_IMPORTED_HOTELS = 'adminPreImportedHotels';
export const ADMIN_PIH_SET_OPTIONS = 'setOptions';
export const ADMIN_PIH_FETCH_HOTELS = 'fetchHotels';
export const ADMIN_PIH_IMPORT_HOTEL = 'importHotel';
export const ADMIN_PIH_UPDATE_HOTEL = 'upateHotel';
export const ADMIN_PIH_MERGE_SYNC = 'mergeSyncHotel';

export const ADMIN_PIH_ACTIVE_TAB = 'active';
export const ADMIN_PIH_IGNORED_TAB = 'ignored';

export const STORE_ADMIN_EDIT_PRE_IMPORTED_HOTELS = 'adminEditPreImportedHotels';
export const ADMIN_EPIH_SET_OPTIONS = 'setOptions';
export const ADMIN_EPIH_SET_ROOMS_INFO = 'setRoomsInfo';
export const ADMIN_EPIH_UPDATE_HOTEL = 'updateHotel';
export const ADMIN_EPIH_SET_ATTRIBUTE_DATA = 'setAttributeData';
export const ADMIN_EPIH_GET_NEARBY_HOTELS = 'getNearbyHotels';
export const ADMIN_EPIH_MERGE_HOTEL = 'mergeHotel';
